import { render } from "./NouvelleVersion.vue?vue&type=template&id=feb3e7be"
import script from "./NouvelleVersion.vue?vue&type=script&lang=js"
export * from "./NouvelleVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__